import { gql } from 'apollo-boost';
import { useMutation } from '../';

const query = gql`
  mutation updateNotificationTemplate(
    $id: Int!,
    $name: String!,
    $template: String!,
  ) {
  updateNotificationTemplate(
    id: $id,
    name: $name,
    template: $template,
  ) {
      success
      id
    }
  }
`;

export function useUpdateNotificationTemplate() {
  const { data, isLoading, mutate } = useMutation();
  const run = (variables, onFinish) => {
    mutate(query, variables, (response) => {
      if (typeof onFinish === 'function') {
        onFinish(response.updateNotificationTemplate.id);
      }
    });
  };
  return { data, isLoading, run };
}
